/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import type { ReactNode } from 'react'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import colors from '@sportninja/common/constants/appColors'

interface SectionTitleProps {
  children: string
  /** Rendered at the right end of the title row, e.g. a column chooser. */
  action?: ReactNode
}

const SectionTitle = ({ children, action }: SectionTitleProps) => {
  return (
    <div css={rowStyle}>
      <p css={titleStyle}>{children}</p>
      {action}
    </div>
  )
}

const rowStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
`

const titleStyle = css`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.DEFAULT_FLAIR};
  text-transform: uppercase;
  margin: 0;
  font-family: ${isCanlan
    ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif'
    : 'BarlowCondensed, Arial, Helvetica, sans-serif'};
`

export default SectionTitle
